(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EvPolicies', EvPolicies);

    EvPolicies.$inject = ['$resource'];

    function EvPolicies ($resource) {
        var resourceUrl =  'api/evPolicies';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
